import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { IArticleItem, GetArticlesResponse } from '../../interfaces/types';

const initialState: GetArticlesResponse = {
    results: [],
    totalResults: 0
};

const articlesSlice = createSlice({
    name: 'articles-slice',
    initialState,
    reducers: {
        setArticles: (state, action: PayloadAction<GetArticlesResponse>) => {
            state.results = action.payload.results;
            state.totalResults = action.payload.totalResults;
        }
    },
})

export const { setArticles } = articlesSlice.actions;
export default articlesSlice.reducer;